<template>
<div id="maincontent">
    <div style="visibility:hidden; opacity:0" class="dropzone"><h2 style="color:white; margin-top: 15em;">Drag your image here</h2></div>
    <div class="d-flex flex-row flex-wrap" id="main" >
    <div class="d-flex flex-column justify-content-between" id="steps">
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Personal Info</p>
                <!-- <p class="bottom-text" style="color: transparent;">Personal Info</p> -->
            </div>
            <div class="col steps-step circle-top">
                <div class="circle active ">1</div>
            </div>
        </div>
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Company</p>
                <!-- <p class="bottom-text" style="color: transparent;">Brief company info</p> -->
            </div>
            <div class="col steps-step grey-circle">
                <div class="circle">2</div>
            </div>
        </div>
        <div class="row justify-content-around">
            <div class="col text-right step-title">
                <p>Your message</p>
                <!-- <p class="bottom-text" style="color: transparent;">Company Description</p> -->
            </div>
            <div class="col steps-step grey-circle">
                    <div class="circle circle-last">3</div>
            </div>
        </div>
    </div>

        <div id="regform">
            <form class="text-left d-flex flex-column justify-content-between">
                <p id="titlename">Personal Info</p>
                <div class="group">
                    <input class="input" v-model="firstname" @input="firstnamechange" :class="{used: firstnameUsed}"/>
                     <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">First Name</label>
                </div>
                <div class="group">
                    <input class="input" v-model="lastname" @input="lastnamechange" :class="{used: lastnameUsed}"/>
                     <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">Last Name</label>
                </div>
                <div class="group">
                    <input class="input" v-model="email" @input="emailchange" :class="{used: emailUsed}" readonly/>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">Email</label>
                </div>
                <div class="group">
                    <input class="input" v-model="city" @input="citychange" :class="{used: cityUsed}"/>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">City</label>
                </div>
                <div class="group">
                    <input class="input" v-model="state" @input="statechange" :class="{used: stateUsed}"/>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">State</label>
                </div>
                <div class="group">
                    <input class="input" v-model="role" @input="rolechange" :class="{used: roleUsed}"/>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">Role</label>
                </div>
                <!-- <div class="select">
                    <select v-model="role" class="select-text" @change="rolechange" :class="{used: roleUsed}"> 
                        <option disabled selected value=""></option>
                        <option v-for="(value, index) in roles" v-bind:value="value" :key="index">{{ value }}</option>
                    </select>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">Role</label>
                </div> -->
                <div class="group">
                    <input class="input" v-model="spiritanimal" @input="spiritanimalchange" :class="{used: spiritanimalUsed}"/>
                     <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="label">Spirit animal</label>
                </div>
                <div id="fileinput">
                    <label id="filelabel" ref="Labelref">Profile picture</label>
                    <img ref="Iconref" class="loaded-image" hidden="true"/>
                    <label class="fileContainer">
                        Choose
                        <input type="file" @change="iconload" accept="image/*" ref="Icon"/>
                    </label>
                 
                </div>
            </form>
            <p v-if="feedback" class="feedback">{{feedback}}</p>
            <div class="form-inline buttons justify-content-center">
                <a class="button">Prev</a>
                <span>|</span>
                <a href="#" class="button" @click.prevent="next">Next</a>
            </div>
        </div>   
    </div>
</div>

</template>
<script>
import firebase from '@/firebase/init'
export default {
    name: 'Step1',
    props:['uid', 'previousfirstname', 'previouslastname', 'previousemail', 'previouscity','previousstate','previousrole', 'previousspiritanimal', 'previousicon', 'previouscompanyName', 'previousbriefdescription', 'previouslogo', 'previousdescription', 'previousmessage'],
    data(){
        return{
            firstname: null,
            lastname: null,
            email: null,
            city: null,
            state: null,
            icon: null,
            role: null,
            spiritanimal: null,
            currentuid: null,
            feedback: null,
            roles:['Founder', 'CEO'],
            firstnameUsed: false,
            lastnameUsed: false,
            emailUsed: false,
            cityUsed: false,
            stateUsed: false,
            roleUsed: false,
            spiritanimalUsed: false
        }
    },
    methods:{
        iconload(e){
            this.setIcon(this.$refs.Icon.files[0])
        },
        setIcon(icon){
            var thisobj = this
            this.icon = icon
            var readerIcon  = new FileReader()
            readerIcon.onloadend = function () {
                let res = readerIcon.result
                callbackIcon(res)
            }

            if (this.icon) {
                readerIcon.readAsDataURL(this.icon)
            } else {
                thisobj.$refs.Iconref.src = ""
            }
            function callbackIcon(data){
                if(thisobj.$refs.Labelref)
                    thisobj.$refs.Labelref.hidden = true
                if(thisobj.$refs.Iconref){
                    thisobj.$refs.Iconref.hidden = false
                    thisobj.$refs.Iconref.src  = data
                }
            }
        },
        next(){
            if(this.firstname && this.lastname && this.email && this.role && this.icon){
                this.$router.push({name: 'Step2', params: {uid: this.currentuid, previousfirstname: this.firstname, previouslastname: this.lastname, previousemail: this.email, previouscity: this.city, previousstate: this.state, previousrole: this.role, 
                previousspiritanimal: this.spiritanimal, previousicon: this.icon, previouscompanyName: this.previouscompanyName, previousbriefdescription: this.previousbriefdescription, previouslogo: this.previouslogo, previousdescription: this.previousdescription, previousmessage: this.previousmessage}} )
            }
            else
                this.feedback = "You must enter all fields"
        },
        firstnamechange(e){
            this.firstname = e.target.value
            if(this.firstname == null || this.firstname == ''){
                this.firstnameUsed = false
            }
            else {this.firstnameUsed = true}
        },
        lastnamechange(e){
            this.lastname = e.target.value
            if(this.lastname == null || this.lastname == ''){
                this.lastnameUsed = false
            }
            else {this.lastnameUsed = true}
        },
        emailchange(){
            if(this.email == null || this.email == ''){
                if(this.previousemail == null)
                    this.emailUsed = false
                }
            else {this.emailUsed = true}
        },
        citychange(e){
            if(this.city == null || this.city == ''){
                if(this.previouscity == null)
                    this.cityUsed = false
                }
            else {this.cityUsed = true}
        },
        statechange(e){
            if(this.state == null || this.state == ''){
                if(this.previousstate == null)
                    this.stateUsed = false
                }
            else {this.stateUsed = true}
        },
        rolechange(){
            if(this.role == null || this.role == ''){
                if(this.previousrole == null)
                    this.roleUsed = false
                }
            else {this.roleUsed = true}
        },
        spiritanimalchange(){
            if(this.spiritanimal == null || this.spiritanimal == ''){
                if(this.previousspiritanimal == null)
                    this.spiritanimalUsed = false
                }
            else {this.spiritanimalUsed = true}
        }
    },
    beforeCreate: function() {
        document.body.className = 'registration'
    },
    created(){
        if(this.uid){
            this.currentuid = this.uid
        }
        if(this.previousfirstname != null && this.previousfirstname != ''){
            this.firstname = this.previousfirstname
            this.firstnameUsed = true
        }
        if(this.previouslastname != null && this.previouslastname != ''){
            this.lastname = this.previouslastname
            this.lastnameUsed = true
        }
        if(this.previousemail != null && this.previousemail != ''){
            this.email = this.previousemail
            this.emailUsed = true
        }
        if(this.previouscity != null && this.previouscity != ''){
            this.city = this.previouscity
            this.cityUsed = true
        }
        if(this.previousstate != null && this.previousstate != ''){
            this.state = this.previousstate
            this.stateUsed = true
        }
        if(this.previousrole != null && this.previousrole != ''){
            this.role = this.previousrole
            this.roleUsed = true
        }
        if(this.previousspiritanimal != null && this.previousspiritanimal != ''){
            this.spiritanimal = this.previousspiritanimal
            this.spiritanimalUsed = true
        }
        if(this.previousicon != null && this.previousicon != undefined){
            this.icon = this.previousicon
        }

        if(!this.uid && !this.previousemail && !this.previousrole && !this.previousicon){
            firebase.auth().onAuthStateChanged((user)=>{
            if(user){
                this.currentuid = user.uid
                this.firstname = null
                this.lastname = null
                this.email = user.email
                this.emailUsed = true
                this.city = null
                this.state = null
                this.role = null
                this.icon = null
                this.spiritanimal - null
            }
            else{
                this.$router.push({name: 'Login'})
            }
            })
        }

        var lastTarget = null;
        window.addEventListener("dragenter", function(e)
        {
            lastTarget = e.target
            document.querySelector(".dropzone").style.visibility = ""
            document.querySelector(".dropzone").style.opacity = 1
        })

        window.addEventListener("dragleave", function(e)
        {
            if(e.target === lastTarget || e.target === document)
            {
                document.querySelector(".dropzone").style.visibility = "hidden"
                document.querySelector(".dropzone").style.opacity = 0
            }
        })
        window.addEventListener("dragover", function(e){
            e.preventDefault()
        })
        var thisRef = this
        window.addEventListener("drop",function(e){
            e.preventDefault()
            e.stopPropagation()
            
            document.querySelector(".dropzone").style.visibility = "hidden"
            document.querySelector(".dropzone").style.opacity = 0

            const files = e.dataTransfer.files
            if(files[0].type.split('/')[0]=='image'){
                thisRef.setIcon(files[0])
            }
            else
                alert("You can upload only image")
        })
        
    },
    mounted(){
        if(this.icon){
            this.setIcon(this.icon)
        }
    }
}
</script>
<style scoped>
div.dropzone
{
    /* positions to point 0,0 - required for z-index */
    position: fixed; top: 0; left: 0; 
    /* above all elements, even if z-index is used elsewhere
       it can be lowered as needed, but this value surpasses
       all elements when used on YouTube for example. */
    z-index: 9999999999;               
    /* takes up 100% of page */
    width: 100%; height: 100%;         
    /* dim the page with 50% black background when visible */
    background-color: rgba(0,0,0,0.5);
    /* a nice fade effect, visibility toggles after 175ms, opacity will animate for 175ms. note display:none cannot be animated.  */
    transition: visibility 175ms, opacity 175ms;
}
.feedback{
    color: red;
}
#maincontent{
    height: 70%;
}
#main{
    /* height: 60%; */
    width: 90%;
     margin-bottom: 2em; 
}
#regform{
    margin-left: auto;
    margin-right: auto;
}
#fileinput{
  margin-top: 2.5em;
}
#titlename{
    color: #8954BA;
    font-size: 18px;
    font-family: Arial, Helvetica, sans-serif;
    margin-bottom: 2em;
}
#steps{
    width: 19em;
    padding-top: 3em;
    padding-bottom: 3em;
    height: 20em;
}
#steps p{
    margin: 0;
    display: inline-block;
    margin-bottom: 2em;
}
.step-title p{
    color: #686868;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.step-title .bottom-text{
    color: #A1A1A1;
}

.button{
    background-color: #5D38DB;
    border-color: white;
    padding: 1.2em 3em;
    border-radius: 7px;
    font-family: GothamBook;
    font-size: 13px;
    color: white !important;
    cursor: pointer !important;
    margin-bottom: 0.5em;
    margin-right: 1em;
    margin-left: 1em;
    font-weight: bold;
    
}

.form-inline span{
    color: #C9C9C9;
    font-size: 1.7em;
}
.circle{
    width: 2em;
    height: 2em;
    text-align: center;
    line-height: 2em;
    border-radius: 1em;
    background: white;
    border: 1px solid #5D38DB;
    color: black !important;
    margin: 0 1em;
    display: inline-block;
    color: white;
    position: relative;
}
.circle::before{
    margin-left: 3px;
    top: 2em;
    bottom: 0;
    position: absolute;
    content: "";
    width: 2px;
    height: 300%;
    background-color: #D9DCE6;
}
.circle-last::before{
    height: 200%;
}
.steps-step.circle-top::before{
    margin-left: 1.9em;
    bottom: 3em;
    position: absolute;
    content: "";
    width: 2px;
    height: 100%;
    background-color: #D9DCE6;
}
.steps-step.grey-circle::before{
    margin-left: 1.7em;
    
    bottom: 4.7em;
    
    position: absolute;
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 1em;
    background-color: #D9DCE6;
}
.steps-step .active{
    background: #5D38DB;
    color: white !important;
}

.group{ 
  position:relative; 
  margin-bottom:35px; 
}
.input{
  font-size:18px;
  padding:10px 10px 10px 5px;
  display:block;
  width:310px;
  border:none;
  border-bottom:1px solid #D0D6E6;
}
.input:focus{ outline:none; }

.label{
  color:#686868; 
  font-size:18px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all;
  font-family: GothamBook;
  font-size: 14px;
}

.used ~.label     {
  top:-20px;
  font-size:14px;
  transition: 0.2s ease all;
  color:#686868;
}
.used{
    color: #8954BA;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.bar  { position:relative; display:block; width:310px; }
.bar:before, .bar:after   {
  content:'';
  height:2px; 
  width:0;
  bottom:1px; 
  position:absolute;
  background:#8954BA; 
  transition:0.2s ease all; 
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%; 
}

.input:focus ~ .bar:before, .input:focus ~ .bar:after {
  width:50%;
}
.highlight {
  position:absolute;
  height:60%; 
  width:100px; 
  top:25%; 
  left:0;
  pointer-events:none;
  opacity:0.5;
  
}

.input:focus ~ .highlight {
  animation:inputHighlighter 0.3s ease;
}

@keyframes inputHighlighter {
  from  { background:#5264AE; }
  to    { width:0; background:transparent; }
}

.select {
	position: relative;
	width: 310px;
}

.select-text {
	position: relative;
	background-color: transparent;
	width: 310px;
	padding: 10px 10px 10px 5px;
	border-radius: 0;
	border: none;
	border-bottom: 1px solid rgba(0,0,0, 0.12);
}

.select-text:focus {
	outline: none;
	border-bottom: 1px solid rgba(0,0,0, 0);
}

.select .select-text {
	appearance: none;
	-webkit-appearance:none
}

.select:after {
	position: absolute;
	top: 18px;
	right: 10px;
	/* Styling the down arrow */
	width: 0;
	height: 0;
	padding: 0;
	content: '';
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 6px solid rgba(0, 0, 0, 0.12);
	pointer-events: none;
}
.select-text:focus ~ .bar:before, .select-text:focus ~ .bar:after {
	width: 50%;
}

.fileContainer {
    overflow: hidden;
    position: relative;
}

.fileContainer [type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
}

.fileContainer {
    background: white;
    border: 1px solid #C1C1C1;
    border-radius: 2px;
    float: right;
    padding: 0.1em 1em 0.1em 1em;
    color: black;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}

.fileContainer [type=file] {
    cursor: pointer;
}
#filelabel{
    color: #686868;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
}
.loaded-image{
    height: 5em;
}
.buttons{
    margin-top: 2em;
}
@media (max-width: 1124px) {
    #steps{
        display: none !important;
    }
}
@media (max-width: 540px){
    #main{
        width: 100%;
    }
    .buttons{
        /* margin-left: 10em; */
    }
    .form-inline span{
        margin-bottom: 0.3em;
    }
    .button{
        margin-bottom: 1em;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Step1.vue